/*=============================
=             Hero            =
=============================*/

var slidesContainer = document.getElementById('slides');

if(slidesContainer) {
	var slides = slidesContainer.querySelectorAll('li'),
		heroControls = document.getElementById('hero-controls'),
		playPauseHero = heroControls.firstElementChild,
		bullets = [].slice.call(heroControls.querySelectorAll('li button')),
		currentBullet = 0,
		heroTimeout,
		runHero = function() {
			currentBullet = (currentBullet + 1) % bullets.length;
			toggleBullets(bullets[currentBullet]);
			startSlide(false);
		};

	setTimeout(startSlide, 0);

	bullets.forEach(function(bullet) {
		bullet.addEventListener('click', function() {
			clearTimeout(heroTimeout);

			toggleBullets(this);
			currentBullet = bullets.indexOf(bullet);
			startSlide(true);
		});
	});

	playPauseHero.addEventListener('click', function() {
		var isPlay = this.classList.contains('play');

		if(isPlay)
			heroTimeout = setTimeout(runHero, 1500);
		else
			clearTimeout(heroTimeout);

		this.className = isPlay ? 'pause' : 'play';
		this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Hero');
	});
}

function startSlide(click) {
	var currentSlide = slidesContainer.querySelector('.current');

	if(slidesContainer.classList.contains('with-animation')) {
		[].slice.call(slidesContainer.querySelectorAll('li:not(.current)')).forEach(function(slide) {
			slide.querySelector('div.title').setAttribute('style', '');
			slide.querySelector('p').setAttribute('style', '');
		});

		setTransition(currentSlide.querySelector('div.title'), currentSlide.querySelectorAll('p'), click);
	}

	if(playPauseHero.classList.contains('pause'))
		heroTimeout = setTimeout(runHero, 7500);
}

function toggleBullets(bullet) {
	var bulletIndex = bullets.indexOf(bullet);

	document.querySelector('#hero-controls .current').classList.remove('current');
	slidesContainer.querySelector('li.current').classList.remove('current');

	slides[bulletIndex].classList.add('current');

	bullet.classList.add('current');
}

function setTransition(title, text, click) {
	setTimeout(function() {
		title.setAttribute('style', 'opacity: 1; transform: none;'+(click ? ' transition: opacity .2s' : ''));
	}, (click ? 100 : 900));

	Velocity(text, {opacity: [1,0]}, (click ? {duration: 200} : {duration: 300, delay: 1700}));
}

// Play/Pause Background Video
[].slice.call(document.querySelectorAll('.video-controls')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var videoPaused = this.classList.contains('play'),
			video = this.parentNode.querySelector('video');

		if(videoPaused)
			video.play();
		else
			video.pause();

		this.classList.toggle('play');

		this.setAttribute('aria-label', (videoPaused ? 'Pause' : 'Play') + ' Video');
	});
});

/*=============================
=          Statistics         =
=============================*/

[].slice.call(document.querySelectorAll('.stat')).forEach(function(stat) {
	var statisticsAnimation = new Waypoint({
		element: stat,
		handler: function(direction) {
			animateCountUp(stat);

			this.destroy();
		},
		offset: '85%'
	});
});

// How long you want the animation to take, in ms
const animationDuration = 2500;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = el => {
	let frame = 0;
	let num = el.querySelector('.number span:first-child');

	const countTo = parseInt(num.innerHTML, 10);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = Math.round(countTo * progress);

		// If the current count has changed, update the element
		if(parseInt(num.innerHTML, 10 ) !== currentCount)
			num.innerHTML = currentCount;

		// If we’ve reached our last frame, stop the animation
		if(frame === totalFrames) {
			clearInterval(counter);
			el.classList.add('done');
		}
	}, frameDuration);
};

/*=============================
=      Testimonials Video     =
=============================*/

var videoFull,
	clickedVideoModalButton;

[].slice.call(document.querySelectorAll('section.testimonials .play-video-modal')).forEach(function(videoModalButton) {
	videoModalButton.addEventListener('click', function() {
		var isIframe = this.classList.contains('iframe');

		clickedVideoModalButton = this;

		videoFull = document.createElement(isIframe ? 'iframe' : 'video');

		videoFull.src = this.dataset.src+(isIframe ? '?autoplay=1&rel=0' : '');

		if(isIframe)
			videoFull.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';

		document.body.appendChild(videoFull);

		videoFull.requestFullscreen();

		if(!isIframe)
			videoFull.play();
	});
});

document.addEventListener('fullscreenchange', function() {
	if(videoFull && !document.fullscreenElement) {
		videoFull.remove();

		if(clickedVideoModalButton)
			clickedVideoModalButton.focus();
	}
});

/*=============================
=          Physicians         =
=============================*/

var doctorsSlider = document.getElementById('doctors-slider');

if(doctorsSlider) {
	var currentCard = 0,
		doctorsCards = doctorsSlider.querySelectorAll('.image-card'),
		cardsTotal = doctorsCards.length;

	// Auto Scroll Slider
	var cardInterval,
		sliderWaypoint = new Waypoint({
	        element: document.querySelector('section.physicians'),
	        handler: function(direction) {
				var autoSlidePhysician = function() {
						slidePhysician('next');
					};

				cardInterval = setInterval(autoSlidePhysician, 5000);

				this.destroy();

	        },
	        offset: '100%'
	    });

	// Next/Prev Buttons
	[].slice.call(doctorsSlider.querySelectorAll('button')).forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(cardInterval);
			slidePhysician(button.className);
		});
	});
}

function slidePhysician(direction) {
	var isNext = direction == 'next',
		numDisplay = checkWidth(1024) ? 2 : (checkWidth(1200) ? 3 : 4),
		cardTransform = doctorsCards[0].offsetWidth + (doctorsCards[1].getBoundingClientRect().left - doctorsCards[0].getBoundingClientRect().right);

	currentCard = (currentCard + numDisplay) == cardsTotal ? 0 : (isNext ? ++currentCard : --currentCard);

	doctorsSlider.querySelector('.image-cards-container').style.transform = 'translateX('+(currentCard ? -(currentCard * cardTransform) : 0)+'px)';
	doctorsSlider.querySelector('button.prev').disabled = currentCard === 0 ? true : false;
	doctorsSlider.querySelector('button.next').disabled = (currentCard + numDisplay) == cardsTotal ? true : false;
}
